import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { LightTaskListTab } from '../components/features/project/LightTaskListTab.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 軽タスクリストページ（旧 MyPage「軽タスクリスト」タブの移設先）。全社共有の軽タスク待機列とセルフ・アサイン導線を、プロジェクト管理フォルダ配下の独立サブページとして表示する。閲覧は全メンバー、リクエストボタンはエンジニア/PMO のみ
 * @graph-connects LightTaskListTab [calls] 軽タスクリスト本体描画
 */
export const Route = createFileRoute('/projects/light-tasks')({
  component: LightTasksPage,
});

/** @graph-connects LightTaskListTab [calls] 軽タスクリスト本体描画 */
function LightTasksPage() {
  return (
    <ProtectedRoute pageKey="lightTasks">
      <div className="space-y-6 animate-fade-in">
        <div className="animate-content-reveal">
          <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">軽タスクリスト</h1>
        </div>
        <LightTaskListTab />
      </div>
    </ProtectedRoute>
  );
}
